import { Fragment, useState } from "react";
import "./App.css";
import HomePage from "./section/HomePage";
import ServicePage from "./section/ServicePage";
import AboutMe from "./section/AboutMe";
import Navbar from "./components/Navbar";
import geo from "./data/geo";
import AutoSlider from "./section/Slider";
import ContactPage from "./section/Contact";
import Scroll from "./section/Scroll";
import Footer from "./section/Footer";

function App() {
  const [language, setLanguage] = useState(geo);

  return (
    <Fragment>
      <Navbar language={language} onClick={(lang) => setLanguage(lang)} />
      <div style={{ height: "90px" }}></div>
      <HomePage language={language} />
      <ServicePage language={language} />
      <AboutMe language={language} />
      <AutoSlider language={language} />
      <ContactPage language={language} />
      <Scroll />
      <Footer />
    </Fragment>
  );
}

export default App;
